export default __webpack_public_path__ + "static/media/aboutDesktop.555c2feb.png";